var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-input',{attrs:{"fluid":"","type":"text"},on:{"input":_vm.onChange},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})}
var staticRenderFns = []

export { render, staticRenderFns }